exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host::ng-deep .mat-focused .mat-input-placeholder {\n  color: #1B4F58;\n}\n\n.mat-focused .mat-input-placeholder {\n  color: #1B4F58;\n}\n\n@media only screen and (max-width: 450px) {\n  #emailDiv {\n    margin-left: 5px !important;\n    margin-right: 5px !important;\n  }\n  #emailInput {\n    margin-left: 5px !important;\n    margin-right: 5px !important;\n    width: 80% !important;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/forgot-password/forgot-password.component.scss
// module id = ../../../../../src/app/forgot-password/forgot-password.component.scss
// module chunks = main